module.exports = __webpack_public_path__ + "img/TradingCertificate.0733d783.jpg";